import React from 'react';
import { Form, Input, InputNumber } from 'antd';
const { Group } = Input;

const Cost = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Стоимость, ₽" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('costFrom')(
          <InputNumber
            min={0}
            style={{ width: '50%' }}
            onChange={e => {
              // todo handleFilterPrice(e, 'periodService')
            }}
            placeholder="от"
          />
        )}
        {getFieldDecorator('costTo')(
          <InputNumber
            style={{ width: '50%' }}
            onChange={e => {
              // todo handleFilterPrice(e, 'periodService')
            }}
            placeholder="до"
            min={0}
          />
        )}
      </Group>
    </Form.Item>
  );
};

export default Cost;
